const CheckNotNull = Symbol('CheckNotNull');

class OtherUserInfo {
    public company_name: string = '';
    public member_typeID: string = '';
    public password: string = '';
    public status: number | null = null;

    constructor(
        company_name: string,
        member_typeID: string,
        password: string,
        status: string
    ) {
        this.company_name = this[CheckNotNull](company_name) ? company_name : '';
        this.member_typeID = this[CheckNotNull](member_typeID) ? member_typeID : '';
        this.password = this[CheckNotNull](password) ? password : '';
        this.status = this[CheckNotNull](status) ? parseInt(status) : null;
    }

    //symbolic methods
    private [CheckNotNull] = (value: string) => {
        if (value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default OtherUserInfo;